import React from "react";
import { Clock } from "lucide-react";


const Timer = ({ timeLeft, isRecording }) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const getTimeColor = (seconds) => {
    if (seconds > 30) return "text-green-600";
    if (seconds > 10) return "text-yellow-600";
    return "text-red-600";
  };

  return (
    <div className="flex items-center justify-center mb-6">
      <div
        className={`relative flex items-center justify-center w-32 h-32 rounded-full border-8 ${
          timeLeft > 30
            ? "border-green-500"
            : timeLeft > 10
            ? "border-yellow-500"
            : "border-red-500"
        } bg-white shadow-lg`}
      >
        <div className="text-center">
          <div className={`text-3xl font-bold ${getTimeColor(timeLeft)}`}>
            {formatTime(timeLeft)}
          </div>
          <div className="text-xs text-gray-500 flex items-center">
            <Clock className="h-3 w-3 mr-1" />
            remaining
          </div>
        </div>
      </div>
    </div>
  );
};


export default Timer